import React, { createContext, useState } from 'react';
import { ThemeProvider } from '@chakra-ui/core';
import { customTheme } from '../src/theme';
import { NonceProvider } from 'react-select';
import { UserProvider } from '../src/contexts'

export const AuthorizationNumberContext = createContext();

const AppProvider = ({ data, children }) => {
  const [authorizationNumber, setAuthorizationNumber] = useState();
  return (
    <UserProvider value={data}>
      <NonceProvider nonce={data.nonce}>
        <ThemeProvider theme={customTheme}>
          <AuthorizationNumberContext.Provider
            value={{
              authorizationNumber: authorizationNumber,
              setAuthorizationNumber: setAuthorizationNumber,
            }}
          >
            {children}
          </AuthorizationNumberContext.Provider>
        </ThemeProvider>
      </NonceProvider>
    </UserProvider>
  );
};

export default AppProvider;